<template>
  <div class="images-container">
    <a v-for="src in validImages" :key="src" :href="src" target="_blank" rel="noopener noreferrer">
      <img :src="src" :alt="src" @error="onError($event)" />
    </a>
  </div>
</template>
<script>
export default {
  name: "CardImages",
  props: ["card"],
  computed: {
    validImages() {
      return this.images.filter(i => !this.badUrls.includes(i));
    },
    images() {
      if (!this.card || !this.card.description) return [];

      const images = [];

      const patterns = [
        /https:\/\/ilfumo\.ru\/_matrix\/media\/v1\/download\/ilfumo\.ru\/[0-9a-zA-Z]+/g,
        /http.?:\/\/[0-9a-zA-Z\.:]+\/telegram\/photo\/[0-9a-zA-Z_-]+/g //что-то и в проде и локально работало
      ];
      for (const pattern of patterns) {
        const patternMatch = this.card.description.match(pattern);
        if (patternMatch) {
          patternMatch.forEach(m => images.push(m));
        }
      }

      return images;
    }
  },
  methods: {
    onError(event) {
      this.badUrls.push(event.srcElement.src);
    }
  },
  data() {
    return {
      badUrls: []
    };
  }
};
</script>

<style scoped>
.images-container {
  overflow-y: auto;
}
.images-container img {
  width: 250px;
  margin: 4px;
}
</style>
